<script setup lang='ts'>
import type { MaybeComputedRef } from '@vueuse/core'
import { useCommentListComponent } from './hooks/comment'
import type { ArticleCommentParams } from '~~/src/server/modules/article/type'

const props = withDefaults(defineProps<{
  title?: boolean
  el?: MaybeComputedRef<HTMLElement | Window | Document | SVGElement | null | undefined>
  commentCount?: number
  param: Omit<ArticleCommentParams, 'pageSize' | 'pageNum'>
}>(), {
  commentCount: 0,
  title: true,
})

const {
  list,
  state,
  pagination,
  getData,
  initHandle,
  mediaNameMap,
} = useCommentListComponent(props)

await initHandle()
</script>

<template>
  <div>
    <h3 v-if="title" mb-4>
      <span class="text-5 font-bold mr-2">全部评论</span>
      <span v-if="pagination.pagination.itemCount" class="text-title-500 text-4">{{ commentCount || pagination.pagination.itemCount }}</span>
    </h3>
    <base-empty
      v-if="state === 'finished' && !list.length" class="py-3"
      icon-class="i-custom-undraw-public-discussion?bg text-50 mt-4"
      text="暂无相关评论"
    />
    <template v-else>
      <base-list v-model:state="state" :el="props.el" @load="getData">
        <ul grid grid-cols-1 gap-4>
          <li v-for="item, index in list" :key="index" class="mb-3 border-b-1 border-gray-100 pb-3">
            <layout-comment-item :item="item" :index="index" :media-name-map="mediaNameMap" />
          </li>
        </ul>
      </base-list>
    </template>
  </div>
</template>
